import useSavedViewCleaner from '@/composables/saved-views/saved-view-cleaner';
import { computed } from 'vue';

export default function useCurrentView(defaultProps, viewsSvc, selectedView) {
  const { clearView } = useSavedViewCleaner();

  const currentView = computed(() => {
    const view = viewsSvc.views.value.find((v) => v.uid === selectedView.value.view.uid);
    if (view === undefined) {
      return viewsSvc.views.value[0];
    }
    return view;
  });

  const clearedCurrentView = computed(() => clearView({
    view: currentView.value,
    props: defaultProps.value,
  }));

  const unsavedChanges = computed(() => viewsSvc.unsavedChanges(currentView.value));

  const hasUnsavedChanges = computed(() => unsavedChanges.value.length > 0);

  return { currentView: clearedCurrentView, hasUnsavedChanges, unsavedChanges };
}
